var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('sidebar-menu',{attrs:{"menu":_vm.userMenu,"collapsed":_vm.collapsed,"theme":"white-theme","width":"224px"},on:{"toggle-collapse":_vm.onToggleCollapse}})}
var staticRenderFns = []

export { render, staticRenderFns }